import { useTranslation } from '../lib/i18n/TranslationContext';
import { Button } from '../ui/Button';

const BossCoracao = () => {
	return (
		<>
			<div className='relative'>
				<img src='https://empreender.nyc3.digitaloceanspaces.com/LP/im/d31d4687e8e6.png' />
			</div>
		</>
	);
};

const FeedBackBoss = ({ description, feedbackLink }: { description: string; feedbackLink: string }) => {
	const { t } = useTranslation();
	return (
		<div className='flex w-full p-10 items-center justify-center gap-4'>
			<div className='flex flex-row gap-4'>
				<div className='flex flex-col gap-4 max-w-[267px]'>
					<p className='text-gray-500 text-xl font-normal leading-7'>{description}</p>

					<Button className='w-16 px-5 py-[6px] box-content' variant='secondary' asChild>
						<a href={feedbackLink} target='_blank'>
							{t('Clique Aqui')}
						</a>
					</Button>
				</div>
				<BossCoracao />
			</div>
		</div>
	);
};

export default FeedBackBoss;
